import React, { HTMLAttributes, useCallback } from 'react';
import { FaPizzaSlice } from 'react-icons/fa';
import { useTheme } from 'styled-components';

import CardItem from '../../../components/CardItem';
import ProgressBar from '../../../components/ProgressBar';

import BRLMoneyFormat from '../../../utils/BRLMoneyFormat';
import handleNumberFormat from '../../../utils/handleNumberFormat';

import noImage from '../../../assets/no_image.png';
import IfoodImage from '../../../assets/ifood.png';
import { productLineTotal } from '../productLineTotal';

import { Container } from './styles';

interface ProductItemProps extends HTMLAttributes<HTMLButtonElement> {
  data: any;
}

const ProductItem: React.FC<ProductItemProps> = ({ data, ...rest }) => {
  const theme = useTheme();

  const handleImage = useCallback((image?: string) => {
    if (image) {
      return `${process.env.REACT_APP_SERVER_URL}/files/${image}`;
    }

    return noImage;
  }, []);

  return (
    <Container {...rest} color={theme.colors.main}>
      {data.ifood ? (
        <section>
          <div className="wrapper">
            <div className="icon-container">
              <img src={handleImage(data.image)} alt={data.name} />
            </div>
            <div className="info">
              {data.pdv ? (
                <header>
                  <strong>{data.name}</strong>
                  <strong>
                    {Number(data.total).toLocaleString('pt-BR', BRLMoneyFormat)}
                  </strong>
                </header>
              ) : (
                <header>
                  <div style={{ textAlign: 'left' }}>
                    <strong>{data.name}</strong>
                    <img
                      src={IfoodImage}
                      alt="ifood"
                      style={{ marginLeft: 10, marginTop: 7 }}
                    />
                  </div>
                  <strong>
                    {Number(data.total).toLocaleString('pt-BR', BRLMoneyFormat)}
                  </strong>
                </header>
              )}

              <footer>
                <span>
                  Quantidade: {handleNumberFormat(Number(data.quantity))}
                </span>
                <span>
                  {Number((data.quantity / data.countProducts) * 100).toFixed(
                    1,
                  )}
                  %
                </span>
              </footer>
            </div>
          </div>
          <ProgressBar
            color={data.color}
            progress={(data.quantity / data.countProducts) * 100}
            className="progress-bar"
          />
        </section>
      ) : (
        <section>
          <div className="wrapper">
            <div className="icon-container">
              {data.produto_controla_grade === 2 ? (
                <FaPizzaSlice size={26} />
              ) : (
                <img
                  src={handleImage(data.produto_imagem)}
                  alt={data.produto_descricao}
                />
              )}
            </div>
            <div className="info">
              <header>
                <strong>{data.produto_descricao}</strong>
                <strong>
                  {productLineTotal(data).toLocaleString(
                    'pt-BR',
                    BRLMoneyFormat,
                  )}
                </strong>
              </header>
              <footer>
                <span>
                  Quantidade:{' '}
                  {Number(data.quantity).toString().indexOf('.') === -1
                    ? handleNumberFormat(Number(data.quantity))
                    : Number(data.quantity).toFixed(3)}
                </span>
                <span>
                  {Number((data.quantity / data.countProducts) * 100).toFixed(
                    1,
                  )}
                  %
                </span>
              </footer>
            </div>
          </div>
          <ProgressBar
            color={data.color}
            progress={(data.quantity / data.countProducts) * 100}
            className="progress-bar"
          />
        </section>
      )}
    </Container>
  );
};

export default ProductItem;
